import produce from 'immer'
import Actions from '../actions'
import { getLocale } from '../i18n'

const initialState = {
  locale: getLocale(),
  selectedLocale: null,
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.CHANGE_LOCALE_RECEIVED: {
      // Needed for re-rendering when locale changes
      draft.locale = payload?.locale
      break
    }
    case Actions.SELECT_CHANGE_LOCALE_REQUESTED: {
      draft.selectedLocale = payload?.locale
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      draft.selectedLocale = null
      break
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
